import { render, staticRenderFns } from "./ResetPassword.view.vue?vue&type=template&id=51c08124&scoped=true&"
import script from "./ResetPassword.view.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.view.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.view.vue?vue&type=style&index=0&id=51c08124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c08124",
  null
  
)

export default component.exports